import { render, staticRenderFns } from "./AccessesTitle.vue?vue&type=template&id=1d22f024&scoped=true"
import script from "./AccessesTitle.vue?vue&type=script&lang=js"
export * from "./AccessesTitle.vue?vue&type=script&lang=js"
import style0 from "./AccessesTitle.vue?vue&type=style&index=0&id=1d22f024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22f024",
  null
  
)

export default component.exports